import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ViewProps from '../types/ViewProps'
import Entry from '../types/Entry'
import Program from '../types/Program'
import Profile from '../types/Profile'
import { useParams } from 'react-router-dom'
import Helmet from 'react-helmet'

interface FormState {
	sending: boolean;
	success: string;
	error: string;
	fields: {
		'EMAIL': string,
		"group[3135]": string,
		"gdpr[28467]": string,
		"b_aaa5bb02d5ff6da16a8980568_54484620fb": string,
	}
}

const defaultFormState = {
	sending: false,
	success: '',
	error: '',
	fields: {
		'EMAIL': '',
		"group[3135]": '',
		"gdpr[28467]": '',
		"b_aaa5bb02d5ff6da16a8980568_54484620fb": '',
	}
}

export default ({ loading, data, entries }: ViewProps) => {
	const [ showVideo, setShowVideo ] = useState<boolean>(false)
	const [ formState, setFormState ] = useState<FormState>(defaultFormState)
	let { profileId, programId } = useParams()

	if (entries === undefined) {
		return (
			<div className="quiz-wrapper result">
				<div className="quiz-content-wrapper">
					<div className="quiz-content">
						<h3>Loading...</h3>
						<Link to="/questions" className='back-link'>Back</Link>
					</div>
				</div>
			</div>
		)
	}

	const profile = entries.find(e => e.id === parseInt(profileId, 10)) as Profile
	const program = entries.find(e => e.id === parseInt(programId, 10)) as Program

	if (!profile || !program) {
		return (
			<div className="quiz-wrapper result">
				<div className="quiz-content-wrapper">
					<div className="quiz-content">
						<h3>No profile or program found</h3>
						<Link to="/questions" className='back-link'>Back</Link>
					</div>
				</div>
			</div>
		)
	}

	// console.log(program)

	// window.scrollTo(0, 0)

	return (
		<div className="quiz-wrapper result">
			<div className="quiz-result-eye" />
			<div className="quiz-content-wrapper">
				<div className="quiz-result-texture">
					<div className="quiz-content">
						<Link to="/questions" className='back-link'>Back</Link>
						<h1>{program.title}</h1>

						<div className="profile">
							<div>
								<h3>Profile</h3>
								<h2>{profile.title}</h2>
								<p className="subheading"><em>{profile.subheading}</em></p>
								<div className="profile-body" dangerouslySetInnerHTML={ {__html: profile.text || ''} } />
							</div>
							<div>
								{!showVideo && (
									<div className="player-image" onClick={_ => setShowVideo(true)}>
										<img src={profile.image} />
										<div className="reticle" />
									</div>
								)}
								{showVideo && (
									<div className="player-iframe">
										<div className="responsive-container">
											<iframe width="560" height="315" src={profile.videoEmbed.replace(/https:\/\/www\.youtube\.com\/watch\?v=(.*)/, 'https://www.youtube.com/embed/$1?autoplay=1')} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
										</div>
										<div className="reticle" />
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
				<div className="program-green-links">
					<div className="quiz-content">
						<div className="">
							<div className="program-body">
								{program.programGreenLinks.map(block => (
									<>
										{block.type === 'heading' && (<h3>{block.content}</h3>)}
										{block.type === 'link' && (<div><a href={block.content.url}>{block.content.text}</a></div>)}
									</>
								))}
							</div>
						</div>
					</div>
				</div>
				<div className="quiz-content">
					<div className="program-bottom-links">
						{program.programBottomLinks.map(block => (
							<>
								{block.type === 'heading' && (<h3>{block.content}</h3>)}
								{block.type === 'links' && (
									<div>
										{block.content.map(link => (
											<a className="link" href={link.url}>
												<img src={link.image} />
												<span>{link.text}</span>
											</a>
										))}
									</div>
								)}
							</>
						))}
					</div>
				</div>
				<div className="newsletter">
					<div className="quiz-content">
						<div id="mc_embed_signup">
							<form action="https://ecuad.us20.list-manage.com/subscribe/post?u=aaa5bb02d5ff6da16a8980568&amp;id=54484620fb" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
								<div id="mc_embed_signup_scroll">
									{/*<div className="indicates-required"><span className="asterisk">*</span> indicates required</div>*/}
									<label htmlFor="mce-EMAIL">
										<h3>Stay Connected</h3>
										<h2>Sign up for the newsletter</h2>
									</label>
									<div className="mc-field-group input-group radio-group">
										<p><strong>I am a</strong></p>
										<ul>
											<li>
												<input type="radio" value="1" name="group[3135]" id="mce-group[3135]-3135-0" />
												<label htmlFor="mce-group[3135]-3135-0">Future Undergrad</label>
											</li>
											<li>
												<input type="radio" value="8" name="group[3135]" id="mce-group[3135]-3135-3" />
												<label htmlFor="mce-group[3135]-3135-3">Future Grad Student</label>
											</li>
											<li>
												<input type="radio" value="2" name="group[3135]" id="mce-group[3135]-3135-1" />
												<label htmlFor="mce-group[3135]-3135-1">Parent</label>
											</li>
											<li>
												<input type="radio" value="4" name="group[3135]" id="mce-group[3135]-3135-2" />
												<label htmlFor="mce-group[3135]-3135-2">Educator</label>
											</li>
										</ul>
									</div>
									<div className="names-group">
										<input
											type="text"
											name="MERGE1"
											className="required email"
											id="mce-first"
											placeholder="First Name"
										/>
										<input
											type="text"
											name="MERGE2"
											className="required email"
											id="mce-last"
											placeholder="Last Name"
										/>
									</div>
									<div className="mc-field-group email-group">
										{/*<label htmlFor="mce-EMAIL">Email Address  <span className="asterisk">*</span></label>*/}
										<input type="email" name="EMAIL" className="required email" id="mce-EMAIL" placeholder="Email address" />
									</div>
									<div id="mce-responses" className="clear">
										<div className="response" id="mce-error-response" style={{display:"none"}}></div>
										<div className="response" id="mce-success-response" style={{display:"none"}}></div>
									</div>
									<div style={{position: "absolute", left: '-5000px'}} aria-hidden="true">
										<input type="text" name="b_aaa5bb02d5ff6da16a8980568_54484620fb" tabIndex={-1} />
									</div>
									<div className="clear">
										<input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button" />
									</div>
									<div id="mergeRow-gdpr" className="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
										<div className="content__gdpr">
											<p>Please select all the ways you would like to hear from Emily Carr University of Art + Design:</p>
											<fieldset className="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">
												<label className="checkbox subfield" htmlFor="gdpr_28467">
													<input type="checkbox" id="gdpr_28467" name="gdpr[28467]" value="Y" className="av-checkbox gdpr" checked /><span>Email</span>
												</label>
											</fieldset>
										</div>
										<div className="content__gdprLegal">
											<p>You can unsubscribe at any time by clicking the link in the footer of our emails. By subscribing you consent to the storage of your personal data (Email Address and Name) outside of Canada as per Mailchimp's privacy practices. Your personal data will only be used for the purposes of providing information you’ve indicated interest in.</p>
											<p>Mailchimp is our marketing platform. By subscribing, you acknowledge that your information will be transferred to Mailchimp for processing, per <a href="https://mailchimp.com/legal/" target="_blank">their privacy practices</a>.</p>
										</div>
									</div>
								</div>
							</form>
							<Helmet>
								<script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script>
								<script type='text/javascript'>{`
(function($) {
	window.fnames = new Array();
	window.ftypes = new Array();
	fnames[0]='EMAIL';
	ftypes[0]='email';
	fnames[1]='FNAME';
	ftypes[1]='text';
	fnames[2]='LNAME';
	ftypes[2]='text';
	fnames[4]='MMERGE4';
	ftypes[4]='text';
	fnames[5]='MMERGE5';
	ftypes[5]='text';
	fnames[6]='MMERGE6';
	ftypes[6]='text';
	fnames[7]='MMERGE7';
	ftypes[7]='text';
	fnames[8]='MMERGE8';
	ftypes[8]='text';
	fnames[9]='MMERGE9';
	ftypes[9]='text';
	fnames[10]='MMERGE10';
	ftypes[10]='text';
	fnames[11]='MMERGE11';
	ftypes[11]='text';
	fnames[3]='MMERGE3';
	ftypes[3]='text';
	fnames[12]='MMERGE12';
	ftypes[12]='text';
	fnames[13]='MMERGE13';
	ftypes[13]='text';
	fnames[14]='MMERGE14';
	ftypes[14]='text';

  // Hack to remove "captcha" text error message that mc-validate.js leaves behind when the captcha is triggered.
	$('body').on('DOMSubtreeModified', '#mce-error-response', function() {
		if ($('#mce-error-response').text() === 'captcha') {
			$('#mce-error-response').hide();
		}
	});
}(jQuery));var $mcj = jQuery.noConflict(true);
								`}</script>
							</Helmet>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
